import type { BaseBlock } from "@/react/components/shared/BuilderUI/DataModel.types";
import type { ElementOrNewElement } from "@/react/types/Element";

import type { BlockMeta } from "../shared/blockUtils";
import { getElementIds } from "../shared/blockUtils";

export const blockToElement = (block: BaseBlock): ElementOrNewElement => {
  const { elementId, elementableId } = getElementIds(block);
  const meta = block.meta as BlockMeta | undefined;

  return {
    id: elementId,
    type: "layout",
    position: meta?.position ?? 0,
    elementable_id: elementableId,
    parent_element_id: meta?.parentElementId ?? null,
    attributes: {
      layout_type: "stack",
      styles: (block.props.styles?.value as Record<string, unknown>) || null,
    },
  } as ElementOrNewElement;
};
